import type { PolicySettings } from '@api/policies/contracts';

const protectionLabels = {
  defenderRealTime: 'Defender real-time', defenderCloud: 'Defender cloud', defenderPua: 'unwanted application blocking',
  smartScreen: 'SmartScreen', networkProtection: 'network protection', edgeProtection: 'Edge protection',
  chromeProtection: 'Chrome Safe Browsing', preventBrowserBypass: 'browser warning bypass prevention',
} as const;

/** Describe resolved desired/planning values, never claim anything was applied to a device. */
export function policySummary(settings: PolicySettings): string {
  const selection = { manual: 'Updates must be selected manually.', security: 'Security updates only.',
    'security-quality': 'Security and quality updates.' }[settings.patchApproval];
  const w = settings.maintenanceWindow;
  const days = [...w.days].sort((a, b) => a - b).map(d => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d]).join(', ');
  const start = `${String(Math.floor(w.startMinute / 60)).padStart(2, '0')}:${String(w.startMinute % 60).padStart(2, '0')}`;
  const off = (Object.keys(protectionLabels) as Array<keyof typeof protectionLabels>).filter(k => !settings[k]);
  return `${settings.excluded ? 'Excluded from patching. ' : ''}${selection} Maintenance: ${days} at ${start} ${w.timeZone} for ${w.durationMinutes} minutes. ${settings.reboot === 'never'
    ? 'No automatic restarts.' : 'Restarts only when idle during maintenance.'} ${off.length
      ? `Protection settings off: ${off.map(k => protectionLabels[k]).join(', ')}.` : 'Protection settings all on.'} ${windowsUpdateSummary(settings)}`;
}

const hour = (h: number) => `${String(h).padStart(2, '0')}:00`;
/** WRMM-328's Windows Update settings, as desired policy only. */
function windowsUpdateSummary(s: PolicySettings): string {
  const delay = s.qualityDeferralDays === 0 ? 'with no delay' : `after ${s.qualityDeferralDays} day${s.qualityDeferralDays === 1 ? '' : 's'}`;
  const version = s.targetVersion === 'none' ? 'no target version' : `Windows 11 ${s.targetVersion}`;
  return `Windows Update: ${s.updateRing === 'pilot' ? 'Pilot' : 'Everyone'} ring, quality updates ${delay}, ${version}, active hours ${hour(s.activeHours.startHour)}–${hour(s.activeHours.endHour)}, installs at ${hour(s.installHour)}.`;
}
